//export const API_URL_DEV = 'https://dsz_api.test/';
export const API_URL_DEV = 'https://api.deutsches-schilddruesenzentrum.de/';
export const API_URL_PRODUCTION = 'https://api.deutsches-schilddruesenzentrum.de/';

export const WEB_URL = 'https://www.deutsches-schilddruesenzentrum.de/'

export const GOOGLE_MAPS_KEY = 'AIzaSyAG42okoESIXMuTUQj1532yxL3yWMitXTw'

export const MODE_DESKTOP = 'DESKTOP';
export const MODE_MOBILE = 'MOBILE';

export const SCHEMA_MAP = 'MAP';
export const SCHEMA_LIST = 'LIST';

export const DEFAULT_ZOOM = 6;
export const DEFAULT_ZOOM_MOBILE = 5.5;
